<!--
  Channel header should show in place of app-header when &context=channel is true. The use case
  for this is when viewing content catalog content from channel. There's currently a bug where
  that's not happening. https://degreedjira.atlassian.net/browse/PD-87408

  As noted in the bug, I don't think this is a good solution anymore. It made sense w/the shared
  CSHTML layouts, but now we should route to channel and keep them in channel while showing the input
  pages as a shared component.

-->

<ng-container *ngIf="!isNativeApp">
  <!-- TODO: Need to figure out how to get hexBrand -->
  <!-- <div id="header-placeholder" style="background-color: @hexBrand; height: 5.5rem; position: fixed; width: 100%; z-index: 0;"></div> -->
  <dgx-skip-nav></dgx-skip-nav>
</ng-container>

<div
  class="l_max-screen"
  [ngClass]="{ 'l_max-screen--no-header': isNativeApp }"
>
  <dgx-channel-header *ngIf="showChannelHeader"></dgx-channel-header>

  <ng-container *ngIf="!showNewLayout">
    <dgx-app-header *ngIf="showAppHeader"></dgx-app-header>
  </ng-container>
  <ng-container *ngIf="showNewLayout">
    <dgx-lxp-nav></dgx-lxp-nav>
  </ng-container>

  <!-- specific to inputs that are hosted, we have a full width view -->
  <ng-container *ngIf="isHostedContent">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="!isHostedContent">
    <div
      class="l_body-wrap"
      [ngClass]="{ 'vertical-nav-padding': showNewLayout }"
    >
      <dgx-breadcrumbs></dgx-breadcrumbs>
      <div
        class="l_content grid center-item"
        ng-class="{ 'drawer-isopen-right': drawerIsOpenRight }"
      >
        <main
          id="main"
          class="l_main rel grid__col-12 grid__col--bleed center-item"
          tabindex="-1"
        >
          <router-outlet></router-outlet>
        </main>
      </div>
      <dgx-cookie-banner
        *dgxFeatureToggle="'degreed-cookie-banner'; hidden: false"
        [userHasAcceptedPrivacyPolicy]="userHasAcceptedPrivacyPolicy"
      ></dgx-cookie-banner>
      <footer class="l_feedback">
        <!-- Keep l_feedback inside the l_body-wrap. Solves z-index issues. -->
        <dgx-zendesk-widget class="js-feedback"></dgx-zendesk-widget>
      </footer>
    </div>
    <dgx-session-timeout></dgx-session-timeout>
  </ng-container>
</div>
